var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0922 9.84843H13.6734L12 4.69687L10.3266 9.84843H4.90781L9.29063 13.0312L7.61719 18.1828L12 15L16.3828 18.1828L14.7094 13.0312L19.0922 9.84843ZM10.5188 12.6328L11.0859 10.8891H12.9188L13.4859 12.6328L12.0047 13.7109L10.5188 12.6328ZM12.5766 9.84843H11.4234L12 8.07187L12.5766 9.84843ZM14.3719 11.9906L14.0156 10.8937H15.8813L14.3719 11.9906ZM9.98906 10.8937L9.63281 11.9906L8.12344 10.8937H9.98906ZM9.6 15.4547L10.1766 13.6781L11.1094 14.3578L9.6 15.4547ZM12.8859 14.3578L13.8188 13.6781L14.3953 15.4547L12.8859 14.3578Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/morocco.fd87409d9e99b9d581fd85db4c639e60.svg";
export { ForwardRef as ReactComponent };